import React, { useEffect, useRef, useState } from 'react';
export default function SystemParametersConfiguration() {

    return (
        <div>
           Parametros del Sistema Configuration
        </div>
    );
}